import { Component, Emit, Prop, Provide, Ref, Vue } from 'vue-property-decorator'
import { ContentAlarmsGrid } from '@/modules/configurationModule/detail/notifications/components/alarms-grid/alarms-grid.models'
import {
    alarmNotificationTypeWithCustomConfiguration,
    AlarmsModalState,
    initialAlarmsModalState
} from '@/modules/configurationModule/detail/notifications/components/alarms-modal/alarms-modal.models'
import { alarmTypeServices } from '@/modules/configurationModule/detail/notifications/services/alarm-type-services'
import AlarmsModalCustomConfiguration
    from '@/modules/configurationModule/detail/notifications/components/alarms-modal-custom-configuration/alarms-modal-custom-configuration.vue'
import AlarmsTypes from '@/modules/configurationModule/detail/notifications/utils/alarmsTypes'
import { CustomConfigurationFormState } from '@/modules/configurationModule/detail/notifications/components/alarms-modal-custom-configuration/alarms-modal-custom-configuration.model'
import { AlarmType } from '@/modules/configurationModule/detail/notifications/models/alarms'
import { BModal } from 'bootstrap-vue'

@Component({
    components: { AlarmsModalCustomConfiguration }
})
export default class AlarmsModal extends Vue {
    @Ref() readonly alarmsModal!: BModal
    @Ref() readonly alarmsModalCustomConfiguration!: any
    @Prop(String) readonly actionTitle!: string
    @Provide() externalValidator = this.$validator
    @Emit()
    update(alarms: AlarmsModalState): AlarmsModalState {
        return {
            id: this.state.id,
            ...alarms
        }
    }
    @Emit()
    create(alarms: AlarmsModalState): AlarmsModalState {
        return alarms
    }
    private state: AlarmsModalState
    private alarmTypes!: AlarmsTypes

    constructor() {
        super()
        this.state = initialAlarmsModalState()
        this.alarmTypes = new AlarmsTypes(null)
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        }) || this.alarmsModalCustomConfiguration?.daysToTargetDateListChanged
    }
    get modelValidated(): boolean {
        const modelValidated = !!this.state.generalConfiguration.alarmType &&
            !!this.state.generalConfiguration.initialWindowInMinutes &&
            !!this.state.generalConfiguration.cronExpression
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors && modelValidated
    }

    get showCustomConfiguration(): boolean {
        const alarmNotificationTypeWithCustomConfigurationList = Object.keys(alarmNotificationTypeWithCustomConfiguration)
        return !!alarmNotificationTypeWithCustomConfigurationList.find((notificationType: string) => notificationType === this.state.generalConfiguration.alarmType?.code)
    }

    async show(selectedRow: ContentAlarmsGrid | null) {
        await this.initializeNotification(selectedRow)
        this.alarmsModal.show()
    }

    async initializeNotification(alarm: ContentAlarmsGrid | null) {
        this.state = initialAlarmsModalState()
        await this.$validator.reset()
        if (alarm) {
            this.state = {
                id: alarm.id,
                active: alarm.active,
                generalConfiguration: {
                    alarmType: alarm.alarmType,
                    initialWindowInMinutes: alarm.initialWindowInMinutes,
                    cronExpression: alarm.cronExpression
                },
                customConfiguration: alarm.customConfiguration
            }
            this.alarmTypes = new AlarmsTypes(alarm.alarmType.code)
        }
    }

    get alarmTypeSelectDisabled(): boolean {
        return !!this.state.id
    }

    get laboratoryId(): number {
        return this.$store.getters.labId
    }

    async getAllAlarmTypes():Promise<AlarmType[] | null> {
        const [err, response] = await this.$_toCall(alarmTypeServices.getAllAlarmTypes())
        if (err) {
            return null
        }
        return response
    }
    mapCustomConfigurationToRequest(alarmsModalCustomConfigurationState: CustomConfigurationFormState) {
        const receiverPersonnelList = alarmsModalCustomConfigurationState.receiverPersonnelList?.map((personnel: any) => personnel.id)
        this.state.customConfiguration.receiverPersonnelIds = receiverPersonnelList ?? []
        this.state.customConfiguration.daysToRemindSampleDiscardDelayed = alarmsModalCustomConfigurationState.daysToDelay
        this.state.customConfiguration.daysToDelay = alarmsModalCustomConfigurationState.daysToDelay
        this.state.customConfiguration.daysBeforeUnlockDelay = alarmsModalCustomConfigurationState.daysToDelay
        this.state.customConfiguration.shouldNotifyPhysicianPetitioner = alarmsModalCustomConfigurationState.shouldNotifyPhysicianPetitioner
        this.state.customConfiguration.shouldNotifyPhysicianDepartment = alarmsModalCustomConfigurationState.shouldNotifyPhysicianDepartment
        this.state.customConfiguration.daysToDiagnosticTargetDateList = alarmsModalCustomConfigurationState.daysToTargetDateList
        this.state.customConfiguration.daysToGlobalTargetDateList = alarmsModalCustomConfigurationState.daysToTargetDateList
    }
    actionModal() {
        if (this.alarmsModalCustomConfiguration) {
            this.mapCustomConfigurationToRequest(this.alarmsModalCustomConfiguration.state.customConfiguration)
        }
        if (this.state?.id) {
            this.update(this.state)
        } else {
            this.create(this.state)
        }
    }

    hide() {
        this.alarmsModal.hide()
    }
}
